<template>
    <div class="min_box">
        <p style="margin-bottom: 15px;color: rgba(0,0,0,.65)">访问数据</p>
        <Seach @dateChang="dateChang " @typeChang="typeChang " :typeNum="num"></Seach>
        <AreaChart2 class="chart"  :data="datas"></AreaChart2>
    </div>
</template>

<script>
    import Seach from "../../components/seach"
    import AreaChart2 from "../../components/areaChart2"
    import API from "../api";
    export default {
        name: "flow",
        data(){
            return{
                num:"3",
                id: this.$route.query.id,
                datas:[

]
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/WebStatistics"; //设置左侧导航2-2 active
        },
        components:{Seach,AreaChart2},
        methods:{
            dateChang(data){
                this.getDetail("",data)
                this.num=""
            },
            typeChang(data){
                this.getDetail(data,"")
                this.num=data
            },
            getDetail(type,date) {
                API.service.FLOW_GET_LIST({a_customer_id:this.id,type:date?"":type||3,search_time:date}).then(res => {
                    let dataArr=[]
                    let dataJson={country:"",year:"",value:""}
                    let time=res.data.data.time
                    let uv=res.data.data.uv_day_total
                    let pv=res.data.data.pv_day_total
                    res.data.data.time.map((item,index)=>{
                        let dataJson={country:"",year:"",value:""}
                        dataJson.country="pv"
                        dataJson.value=pv[index]
                        dataJson.year=time[index]
                        dataArr.push(dataJson)
                    })
                    res.data.data.time.map((item,index)=>{
                        let dataJson={country:"",year:"",value:""}
                        dataJson.country="uv"
                        dataJson.value=uv[index]
                        dataJson.year=time[index]
                        dataArr.push(dataJson)
                    })
                    let dataArrs=[]
                    dataArr.map((item,index)=>{
                        let dataJsons={value:item.value*1,country:item.country,year:item.year,  }
                        dataArrs=[...dataArrs,dataJsons]
                    })
                    this.datas=dataArrs
                })
            }
        },
        mounted() {
            this.getDetail()
        }
    }
</script>

<style scoped>
.chart{margin-top:40px}
.min_box{width: 70%}
</style>
